import { FC, useId } from 'react'
import cn from 'classnames'
import styles from './neon.module.scss'

interface Props {
  color: 'purple' | 'green'
  size?: number
  flip?: boolean
  className?: string
}

const DEFAULT_SIZE = 160

/**
 * Decorative low-poly crystal shard drawn with inline SVG.
 * Colour comes from `currentColor`, so it follows the neon tokens.
 */
export const NeonCrystal: FC<Props> = ({
  color,
  size = DEFAULT_SIZE,
  flip = false,
  className
}) => {
  const filterId = useId()

  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 160 160'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden
      className={cn(styles.crystal, className)}
      data-color={color}
      style={flip ? { transform: 'scaleX(-1)' } : undefined}
    >
      <defs>
        <filter
          id={filterId}
          x='-40%'
          y='-40%'
          width='180%'
          height='180%'
        >
          <feGaussianBlur stdDeviation='10' />
        </filter>
      </defs>

      <g
        filter={`url(#${filterId})`}
        opacity='0.55'
      >
        <polygon
          points='80,8 122,60 100,150 52,140 30,70'
          fill='currentColor'
        />
      </g>

      <polygon
        points='80,8 122,60 100,150 52,140 30,70'
        fill='currentColor'
        opacity='0.35'
      />

      <polygon
        points='80,8 122,60 90,90'
        fill='currentColor'
        opacity='0.75'
      />

      <polygon
        points='80,8 30,70 66,86'
        fill='currentColor'
        opacity='0.5'
      />

      <polygon
        points='66,86 90,90 100,150 52,140'
        fill='currentColor'
        opacity='0.45'
      />

      <polygon
        points='90,90 122,60 100,150'
        fill='currentColor'
        opacity='0.9'
      />

      <polygon
        points='120,120 150,130 138,158 112,146'
        fill='currentColor'
        opacity='0.6'
      />

      <polygon
        points='14,112 40,104 34,134'
        fill='currentColor'
        opacity='0.5'
      />
    </svg>
  )
}
